import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('tokenHydros99'));

  const saveToken = (userToken) => {
    localStorage.setItem('tokenHydros99', userToken);
    setToken(userToken);
  };

  const removeToken = () => {
    localStorage.removeItem('tokenHydros99');
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, setToken: saveToken, removeToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
